<template>
  <div>
    <el-upload
      class="upload-demo"
      ref="upload"
      action="https://yytools-api.mockuai.com/api/test/file/upload"
      accept=".rar,.zip"
      :headers="headers"
      :on-change="handleChange"
      :on-remove="handleRemove"
      :on-success="excelSuccess"
      :on-progress="starUpload"
      :show-file-list="false"
      :limit="1"
      :auto-upload="true"
    >
      <el-button size="small" type="primary" :loading="loading">{{
        loading ? "正在上传" : "上传文件"
      }}</el-button>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: "upload-data",
  data() {
    return {
      limitUpload: 1,
      fileTemp: null,
      loading: false,
      headers: {
        Authorization: lib.cookie.get('yytools_token'),
      },
    };
  },
  mounted() {
    console.log(this.config);
  },
  methods: {
    handleChange(file, fileList) {
      this.fileTemp = file.raw;
    },

    handleRemove(file, fileList) {
      this.fileTemp = null;
    },
    starUpload() {
      this.loading = true;
    },
    excelSuccess(res) {
      this.$emit('success');
      this.$refs.upload.clearFiles();
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.up-layout {
  display: flex;
}
</style>
